import { c as _c } from "react/compiler-runtime";
import { SimpleGrid } from '@chakra-ui/react';
import { RadioCardItem, RadioCardRoot } from '@src/components/chakra-ui/radio-card';
import { LuCalendarOff, LuCalendarCheck } from 'react-icons/lu';
type SessionAvailabilityPickerProps = {
  open: boolean;
  /** True when bookings are on and a valid rate is set. */
  canAccept: boolean;
  onOpenChange: (open: boolean) => void;
};

/** Two-up choice cards for whether founders can book paid sessions. */
export const SessionAvailabilityPicker = t0 => {
  const $ = _c(13);
  const {
    open,
    canAccept,
    onOpenChange
  } = t0;
  const t1 = open ? "open" : "paused";
  let t2;
  if ($[0] !== onOpenChange) {
    t2 = details => {
      if (details.value === "open" || details.value === "paused") {
        onOpenChange(details.value === "open");
      }
    };
    $[0] = onOpenChange;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      base: 1,
      sm: 2
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <LuCalendarCheck />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = canAccept ? "Founders can request a session at your listed rate." : "Set an hourly rate, including $0, to go live.";
  let t6;
  if ($[4] !== t5) {
    t6 = <RadioCardItem icon={t4} indicatorPlacement="start" label="Open for bookings" value="open" description={t5} />;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <RadioCardItem description="Booking is off. Your profile and rates stay as they are." icon={<LuCalendarOff />} indicatorPlacement="start" label="Not taking sessions" value="paused" />;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t6) {
    t8 = <SimpleGrid columns={t3} gap={3}>{t6}{t7}</SimpleGrid>;
    $[7] = t6;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t1 || $[10] !== t2 || $[11] !== t8) {
    t9 = <RadioCardRoot colorPalette="teal" size="lg" value={t1} variant="outline" onValueChange={t2}>{t8}</RadioCardRoot>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  return t9;
};